module.exports = __webpack_public_path__ + "static/media/14-min.6c46afe1.jpg";